<div class="accordion" id="accordionWerkelijkRendement" style="margin-top: -30px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOWR">
            <button aria-controls="collapseOWR" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseOWR" data-bs-toggle="collapse" type="button">
                Opgeven werkelijk rendement
            </button>
        </h2>
        <div aria-labelledby="headingOWR" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseOWR">
            <div class="accordion-body">
                Heeft de aangever en/of partner box 3-inkomen over {{ this.year }}? Dan kun je het werkelijk rendement
                invullen in de aangifte
                inkomstenbelasting {{ this.year }}.
                <div class="space10"></div>
                Bij het aangifte doen geef je aan de ene kant het vermogen door op de manier zoals we altijd gewend
                zijn: de waarde van de bezittingen en schulden op de peildatum 1 januari van het aangiftejaar. <br/>
                Is het vermogen hoger dan het heffingsvrij vermogen? Dan kun je ook het werkelijk rendement
                doorgeven. Dat is niet verplicht. Maar als je daarvoor kiest, dan berekenen we uw belasting op 2
                manieren: met het fictief rendement
                en met het werkelijk rendement. We gebruiken altijd het bedrag dat het voordeligst is voor de
                belastingplichtige.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOWR1">
            <button aria-controls="collapseOWR1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseOWR1" data-bs-toggle="collapse" type="button">
                Invullen werkelijk rendement in Snelstart Fiscaal
            </button>
        </h2>
        <div aria-labelledby="headingOWR1" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement" id="collapseOWR1">
            <div class="accordion-body">
                Bij de bezittingen en schulden vind je naast de bekende zaken als omschrijvingen, rekeningnummers en
                bedragen nu ook <b>een button 'OWR'</b>. Door te klikken op de button opent zich een (kleiner) scherm, waarin
                de vragen staan voor het opgeven van het werkelijk rendement. Dat zijn dan zaken als 'Waarde per 31
                december {{ this.year }}', 'Ontvangen rente' of 'Aankopen/Stortingen'. Met de ingevulde waarden wordt
                naast het fictieve rendement ook het werkelijke rendement berekend.
                <div class="space10"></div>
                Je vindt een opstelling van het werkelijk rendement bij het onderdeel 'Box 3 - Samenvatting'.
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBank">
            <button aria-controls="collapseBank" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseBank" data-bs-toggle="collapse" type="button">
                OWR & Bank- en spaartegoeden
            </button>
        </h2>
        <div aria-labelledby="headingBank" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseBank">
            <div class="accordion-body">
                Voor bank- en spaartegoeden in het binnen- en buitenland heb je de volgende gegevens nodig:
                <li class="list">naam en rekeningnummer (IBAN) van elke bank- en spaarrekening</li>
                <li class="list">overzicht(en) van de ontvangen rente. Het gaat om de rente die de bank in 2025 op de
                    rekening heeft bijgeschreven.
                </li>
                <li class="list">als er een buitenlandse rekening is: de ontvangen rente in euro's. Kijk op de site van
                    de Europese Centrale Bank (ECB) naar de wisselkoers.
                </li>
                <div class="space10"></div>
                <b>Let op</b><br/>
                Kosten voor een bank- of spaarrekening hoef je niet op te zoeken. Deze kosten zijn niet aftrekbaar bij
                het werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVve">
            <button aria-controls="collapseVve" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseVve" data-bs-toggle="collapse" type="button">
                OWR & Vereniging van eigenaren (vve)
            </button>
        </h2>
        <div aria-labelledby="headingVve" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseVve">
            <div class="accordion-body">
                Als iemand lid bent is een vve, dan heb je nodig:
                <li class="list">de ontvangen rente over het aandeel in het vermogen van de vve</li>
                <div class="space10"></div>
                Kijk voor de ontvangen rente op de jaarrekening van de vve. Het aandeel vind je in de splitsingsakte. Je
                kunt de ontvangen rente of de splitsingsakte ook opvragen bij de vve-beheerder.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBeleggingen">
            <button aria-controls="collapseBeleggingen" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseBeleggingen" data-bs-toggle="collapse" type="button">
                OWR & Beleggingen
            </button>
        </h2>
        <div aria-labelledby="headingBeleggingen" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseBeleggingen">
            <div class="accordion-body">
                Bij beleggingen houd je de volgende gegevens bij de hand:
                <li class="list">een jaaroverzicht van de ontvangen inkomsten, maar zonder de ingehouden
                    dividendbelasting (denk aan: bruto-dividend, rente op obligaties)
                </li>
                <li class="list">de waarde op 1 januari en op 31 december. Gebruik hiervoor het jaaroverzicht of
                    portefeuilleoverzicht van de bank of verzekeraar.
                </li>
                <li class="list">de totale waarde van de aankopen en verkopen van dat jaar</li>
                <li class="list">de naam van het beleggingsfonds of van de beleggingen</li>
                <li class="list">het nummer van de beleggingsrekening</li>
                <div class="space10"></div>

                <b>Beleggingen in buitenlandse valuta</b><br/>
                Zijn de beleggingen in buitenlandse valuta? Dan heb je ook nodig:
                <li class="list">de ontvangen dividend of rente in euro's. Kijk op de site van de ECB naar de
                    wisselkoers op de dag van ontvangst.
                </li>
                <li class="list">het land waar de persoon de belegging had of waar de beleggingsinstelling was
                    gevestigd
                </li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Gemaakte kosten, zoals beheer- en administratiekosten, hoef je niet op te zoeken. Deze kosten zijn niet
                aftrekbaar bij het werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingCrypto">
            <button aria-controls="collapseCrypto" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseCrypto" data-bs-toggle="collapse" type="button">
                OWR & Cryptovaluta
            </button>
        </h2>
        <div aria-labelledby="headingCrypto" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseCrypto">
            <div class="accordion-body">
                Bij cryptobezittingen die met bewaart in de wallet, bij een exchange of bij een andere partij,zijn de
                volgende gegevens van belang:
                <li class="list">de waarde op 1 januari en 31 december. Dit staat bijvoorbeeld in een jaaroverzicht van
                    de verstrekker van de cryptovaluta. Had de persoon op 1 januari de cryptovaluta nog niet? Dan
                    gebruik je de aankoopwaarde. Had de peroon op 31 december de cryptovaluta niet meer? Dan gebruik je
                    de verkoopwaarde.
                </li>
                <li class="list">de totale waarde van aankopen en verkopen over het hele jaar</li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Kosten zoals handelskosten of een vergoeding (fee) hoef je niet op te zoeken. Deze kosten zijn niet
                aftrekbaar bij het werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2eWoning">
            <button aria-controls="collapse2eWoning" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2eWoning" data-bs-toggle="collapse" type="button">
                OWR & 2e woning
            </button>
        </h2>
        <div aria-labelledby="heading2eWoning" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapse2eWoning">
            <div class="accordion-body">
                Bij een 2e woning heb je de volgende gegevens nodig:
                <li class="list">adresgegevens</li>
                <li class="list">de WOZ-waarde van het jaar zelf en van het jaar erna. Je vindt de WOZ-waarde op de
                    WOZ-beschikking die men heeft gekregen van de gemeente.
                </li>
                <div class="space10"></div>

                <b>2e woning in het buitenland</b><br/>
                Staat je 2e woning in het buitenland? Dan heb je nodig:
                <li class="list">adresgegevens</li>
                <li class="list">de waarde op 1 januari of aankoopdatum (waarde in het economisch verkeer)</li>
                <li class="list">de waarde op 31 december of verkoopdatum (waarde in het economisch verkeer)</li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Kosten zoals onderhoudskosten hoef je niet op te zoeken. Deze kosten zijn niet aftrekbaar bij het
                werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVerhuurdeWoning">
            <button aria-controls="collapseVerhuurdeWoning" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseVerhuurdeWoning" data-bs-toggle="collapse"
                    type="button">
                OWR & Verhuurde woning
            </button>
        </h2>
        <div aria-labelledby="headingVerhuurdeWoning" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseVerhuurdeWoning">
            <div class="accordion-body">
                Bij een woning die men (een deel van het jaar) verhuurt, heb je de volgende gegevens nodig:
                <li class="list">adresgegevens</li>
                <li class="list">de WOZ-waarde van het jaar zelf en van het jaar erna</li>
                <li class="list">huur- of pachtontvangsten (gebruik hiervoor een bankafschrift of een
                    huurovereenkomst)
                </li>
                <div class="space10"></div>

                <b>Verhuurde woning in het buitenland</b><br/>
                Staat de verhuurde woning in het buitenland? Dan heb je nodig:
                <li class="list">adresgegevens</li>
                <li class="list">de waarde op 1 januari of aankoopdatum (waarde in het economisch verkeer)</li>
                <li class="list">de waarde op 31 december of verkoopdatum (waarde in het economisch verkeer)</li>
                <li class="list">huur- of pachtontvangsten</li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Kosten zoals onderhoudskosten hoef je niet op te zoeken. Deze kosten zijn niet aftrekbaar bij het
                werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOverigeOnroerend">
            <button aria-controls="collapseOverigeOnroerend" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseOverigeOnroerend" data-bs-toggle="collapse"
                    type="button">
                OWR & Overige onroerende zaken
            </button>
        </h2>
        <div aria-labelledby="headingOverigeOnroerend" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseOverigeOnroerend">
            <div class="accordion-body">
                Bij overige onroerende zaken heb je de volgende gegevens nodig:
                <li class="list">adresgegevens</li>
                <li class="list">de waarde op 1 januari of aankoopdatum (waarde in het economisch verkeer)</li>
                <li class="list">de waarde op 31 december of verkoopdatum (waarde in het economisch verkeer)</li>
                <li class="list">huur- of pachtontvangsten (gebruik hiervoor een bankafschrift of een
                    huurovereenkomst)
                </li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Kosten zoals onderhoudskosten hoef je niet op te zoeken. Deze kosten zijn niet aftrekbaar bij het
                werkelijk rendement.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingInvestering">
            <button aria-controls="collapseInvestering" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseInvestering" data-bs-toggle="collapse" type="button">
                OWR & Geïnvesteerd in onroerend goed
            </button>
        </h2>
        <div aria-labelledby="headingInvestering" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseInvestering">
            <div class="accordion-body">
                Bij een verbetering of uitbreiding aan 1 of meerdere onroerende zaken houd je de volgende gegevens bij
                de hand:
                <li class="list">het totaalbedrag van de investering</li>
                <li class="list">het bedrag van de investering dat heeft geleid tot een waardestijging</li>
                <div class="space10"></div>

                <b>Investering in 2e woning</b><br/>
                Heb je een investering gedaan in een 2e woning? Dan moet op de WOZ-beschikking van de 2e woning staan
                dat men een investering hebt gedaan. Op de WOZ-beschikking staat dan dat artikel 18, lid 3 van de Wet
                WOZ is toegepast.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingVorderingen">
            <button aria-controls="collapseVorderingen" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseVorderingen" data-bs-toggle="collapse" type="button">
                OWR & Vorderingen
            </button>
        </h2>
        <div aria-labelledby="headingVorderingen" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseVorderingen">
            <div class="accordion-body">
                Bij vorderingen waarbij de persoon geld heeft uitgeleend, houd je de volgende gegevens bij de hand:
                <li class="list">de ontvangen rente op het bedrag dat de persoon heeft uitgeleend (gebruik hiervoor
                    bijvoorbeeld een bankafschrift of een overeenkomst)
                </li>
                <li class="list">de waarde van de vordering op 1 januari en op 31 december</li>
                <li class="list">het bedrag dat de persoon in het jaar heeft uitgeleend (gebruik hiervoor de
                    overeenkomst van de lening of de bankafschriften)
                </li>
                <li class="list">de ontvangen aflossing (dit kun je terugvinden op de bankafschriften)</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingContant">
            <button aria-controls="collapseContant" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseContant" data-bs-toggle="collapse" type="button">
                OWR & Contant geld in vreemde valuta
            </button>
        </h2>
        <div aria-labelledby="headingContant" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseContant">
            <div class="accordion-body">
                Bij contant geld in andere valuta dan euro's houd je de volgende gegevens bij de hand:
                <li class="list">de waarde in euro's op 1 januari en op 31 december of op de datum dat je ze kocht of
                    weer verkocht
                </li>
                <div class="space10"></div>
                Kijk voor de wisselkoers op de site van de Europese Centrale Bank (ECB).
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAndereBezittingen">
            <button aria-controls="collapseAndereBezittingen" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseAndereBezittingen" data-bs-toggle="collapse"
                    type="button">
                OWR & Andere bezittingen
            </button>
        </h2>
        <div aria-labelledby="headingAndereBezittingen" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseAndereBezittingen">
            <div class="accordion-body">
                Onder andere bezittingen vallen bijvoorbeeld het niet-vrijgestelde deel van een kapitaalverzekering,
                periodieke uitkeringen en overige bezittingen.
                <div class="space10"></div>

                Bij deze bezittingen heb je de volgende gegevens nodig:
                <li class="list">de waarde op 1 januari en 31 december. Dit staat bijvoorbeeld in een jaaroverzicht. Had
                    de persoon op 1 januari de andere bezitting nog niet? Dan gebruik je de aankoopwaarde. Had de
                    persoon op 31 december de andere bezitting niet meer? Dan gebruik je de verkoopwaarde.
                </li>
                <li class="list">de totale waarde van betaalde premies en ontvangen uitkeringen over het hele jaar</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingSchulden">
            <button aria-controls="collapseSchulden" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapseSchulden" data-bs-toggle="collapse" type="button">
                OWR & Schulden
            </button>
        </h2>
        <div aria-labelledby="headingSchulden" class="accordion-collapse collapse"
             data-bs-parent="#accordionWerkelijkRendement"
             id="collapseSchulden">
            <div class="accordion-body">
                Bij schulden houd je voor elke schuld de volgende gegevens bij de hand:
                <li class="list">de naam van de (geld)verstrekker</li>
                <li class="list">de betaalde rente (gebruik hiervoor bankafschriften, een leenovereenkomst of een
                    jaaroverzicht)
                </li>
                <div class="space10"></div>

                <b>Schulden in buitenlandse valuta</b><br/>
                Heeft de persoon schulden in buitenlandse valuta? Dan heb je ook nodig:
                <li class="list">de betaalde rente in euro's. Kijk op de site van de ECB naar de wisselkoers op de dag
                    van ontvangst.
                </li>
                <li class="list">het bedrag van de schuld op 1 januari en 31 december omgerekend naar euro's</li>
                <li class="list">het bedrag waarmee de persoon de schuld heeft afgelost en het bedrag waarmee de persoon
                    de schuld hebt verhoogd. Had de persoon op 1 januari de schuld nog niet? Gebruik dan het bedrag
                    waarmee de persoon de schuld is aangegaan.
                </li>
                <div class="space10"></div>

                <b>Let op</b><br/>
                Kosten, zoals financieringskosten of boeterente, hoef je niet op te zoeken. Deze kosten zijn niet
                aftrekbaar.
            </div>
        </div>
    </div>
</div>
